module.exports = __webpack_public_path__ + "__static/site-1751025561283/img/how-works-mobile.a9005861.svg";